import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import Script from 'next/script'

import useIsConsentGroupEnabled from 'hooks/useIsConsentGroupEnabled'

import { getUser } from 'state/session/selectors'
import { getSegmentIds } from 'state/ads/selectors'

import { MapUserGenderToAdGender } from 'constants/ads'
import { ConsentGroup } from 'constants/consent'

import {
  initGoogletag,
  setupGoogletagServices,
  setAdsGenderValue,
  setAdsSegments,
  seNonPersonalizedAds,
} from './utils'

const Google = () => {
  const user = useSelector(getUser)
  const adsSegmentIds = useSelector(getSegmentIds)
  const hasConsentedTargeting = useIsConsentGroupEnabled(ConsentGroup.Targeting)

  const adsGenderValue = useMemo(() => user && MapUserGenderToAdGender[user.gender], [user])

  useEffect(() => {
    initGoogletag()
    setupGoogletagServices()
  }, [])

  useEffect(() => {
    seNonPersonalizedAds(!hasConsentedTargeting)
  }, [hasConsentedTargeting])

  useEffect(() => {
    setAdsGenderValue(adsGenderValue)
  }, [adsGenderValue])

  useEffect(() => {
    setAdsSegments(adsSegmentIds)
  }, [adsSegmentIds])

  return (
    <Script
      id="googletag-script"
      data-testid="googletag-script"
      src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
      strategy="lazyOnload"
    />
  )
}

export default Google
